// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3Z-0U","buttons":"SendReceipts_buttons__30ZVc","email":"SendReceipts_email__Cefzy","bookApptTitle":"SendReceipts_bookApptTitle__ZPr6j"};